<template>
  <div>
    <h4
      style="
        margin: auto;
        width: 50%;
        font-weight: bold;
        text-align: center;
        font-size: 20px;
      "
    >
      KETIDAKSESUAIAN ITEM FPB DENGAN RAB
      <v-tooltip bottom color="grey">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            x-small
            text
            icon
            color="grey darken-2"
            @click="refreshData"
          >
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>refresh page</span>
      </v-tooltip>
    </h4>
    <v-card
      style="
        margin-top: 20px;
        margin-right: 10px;
        margin-left: 10px;
        margin-bottom: 30px;
        padding: 10px;
      "
    >
      <v-row no-gutters>
        <v-col cols="12">
          <div
            style="border-radius: 10px 10px 0 0"
            :class="`d-flex justify-space-between ${
              wWidth < 769 ? 'flex-column' : 'flex-row'
            }`"
          >
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div
                v-if="
                  getUserProfile.level.find(
                    ({ id }) => id === '1' || id === '3'
                  ) !== undefined
                "
              >
                <v-btn
                  v-if="wWidth > 768"
                  outlined
                  small
                  elevation="1"
                  color="indigo"
                  class="indigo--text"
                  style="font-size: 12px; margin-right: 20px"
                  @click="exportData"
                >
                  Export Data
                </v-btn>
              </div>
            </div>
            <div
              style="
                position: relative;
                top: 15px;
                margin: 0 10px;
                font-size: 12px;
                width: 210px;
              "
            >
              <v-autocomplete
                v-if="
                  getUserProfile.level.find(({ id }) => id === '41') !==
                  undefined
                "
                label="- Cari di Plant -"
                v-model="paramAPI.company_id"
                :items="dropdownCompany"
                @change="changeCompany"
                item-text="name"
                item-value="id"
                return-id
                outlined
                dense
                style="margin: 0"
                clearable
              ></v-autocomplete>
              <v-autocomplete
                v-else
                label="- Cari di Plant -"
                v-model="paramAPI.company_id"
                :items="dropdownCompany"
                @change="changeCompany"
                item-text="name"
                item-value="id"
                return-id
                outlined
                dense
                style="margin: 0"
                :disabled="isDisableCompanyDropdown"
                clearable
              ></v-autocomplete>
            </div>
            <div
              style="
                position: relative;
                top: 15px;
                margin: 0 10px;
                font-size: 12px;
                width: 210px;
              "
            >
              <v-select
                v-model="paramAPI.project_id"
                label="Cari Project"
                :items="dropdownProject"
                :item-text="getItemText"
                :filter="customFilter"
                item-value="id"
                outlined
                return-id
                dense
                clearable
                @change="projectWatcher"
              >
                <template v-slot:item="{ item }">
                  <div
                    style="
                      background: rgba(255, 255, 255, 0.1);
                      font-size: 12px;
                    "
                  >
                    {{ '(' + item.code + ')' + ' ' + item.name }}
                  </div>
                </template>
              </v-select>
            </div>
            <div
              style="
                position: relative;
                top: 15px;
                margin: 0 10px;
                font-size: 12px;
                width: 210px;
              "
            >
              <v-select
                v-model="paramAPI.budget_plan_id"
                label="Cari RAB"
                :items="dropdownRab"
                item-text="name"
                item-value="id"
                outlined
                return-id
                dense
                clearable
                @change="rabWatcher"
              >
              </v-select>
            </div>
            <div
              v-if="wWidth > 768"
              style="
                position: relative;
                top: 15px;
                margin: 0 0;
                font-size: 12px;
              "
              class="d-flex"
            >
              <v-select
                label="- Cari Kategori -"
                v-model="paramAPI.category_item"
                :items="dropdownCategoryItem"
                @change="changeCategory"
                item-text="name"
                item-value="id"
                return-id
                outlined
                dense
                style="margin: 0; height: 42px"
                clearable
              ></v-select>
            </div>
          </div>
        </v-col>
        <v-col cols="7">
          <v-select
            :disabled="selectedData.length == 0 || paramAPI.company_id == null"
            label="Action"
            v-model="actionValue"
            :items="itemsAction"
            item-text="name"
            item-value="id"
            outlined
            return-id
            dense
            @change="actionSelect"
            style="width: 210px"
          ></v-select>
        </v-col>
        <v-col cols="5" style="padding-left: 17px">
          <v-text-field
            v-model="paramAPI.keyword"
            @keyup.enter="searchEnter"
            label="Ketik sesuatu disini..."
            type="search"
            outlined
            dense
            append-icon="mdi-magnify"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-data-table
            v-model="selectedData"
            style="cursor: pointer"
            @click:row="rowClick"
            mobile-breakpoint="0"
            height="50vh"
            class="elevation-1"
            :headers="deviationHeaders"
            :items="result"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [1, 3, 5, 10, 15, 100, 1000]
            }"
            :server-items-length="totalData"
            :page="paramAPI.page"
            :items-per-page="paramAPI.itemsPerPage"
            @update:page="updatePage"
            @update:items-per-page="updateItemPerPage"
            item-key="id"
            :show-select="
              getUserProfile.level.find(({ id }) => id === '41') === undefined
            "
            disabled
          >
            <template v-slot:[`item.request_no`]="{ item }">
              <div style="font-size: 13px; font-weight: bolder">
                {{ item.request_no }}
              </div>
            </template>
            <!-- <template v-slot:[`item.employee`]="{ item }">
              <div style="width: 125px; font-size: 12px">
                {{ item.employee.name }}
              </div>
            </template> -->
            <!-- <template v-slot:[`item.company`]="{ item }">
              <div style="width: 125px; font-size: 12px">
                {{ item.company.name }}
              </div>
            </template> -->
            <template v-slot:[`item.project`]="{ item }">
              <div style="width: 180px; font-size: 12px">
                {{
                  `${
                    item.project != null
                      ? '(' + item.project.code + ') ' + item.project.name
                      : null
                  }`
                }}
              </div>
            </template>
            <template v-slot:[`item.rab`]="{ item }">
              <div style="width: 180px; font-size: 12px">
                {{ item.rab != null ? item.rab.name : null }}
              </div>
            </template>
            <template v-slot:[`item.product`]="{ item }">
              <div class="d-flex">
                <v-tooltip top color="white">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="
                        item.is_subtitute ||
                        (item.rab_qty_gap != null && item.rab_qty_gap < 0)
                      "
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      color="red"
                      class="mr-1"
                      >mdi-alert</v-icon
                    >
                  </template>
                  <div
                    style="
                      width: 250px;
                      border: 1px solid darkslategrey;
                      padding: 5px;
                      border-radius: 3px;
                      margin: 0;
                    "
                  >
                    <div class="black--text" style="font-size: 12px">
                      <div v-if="item.is_subtitute">
                        Nama barang tidak sesuai RAB <br />
                        <span style="font-size: 10px">
                          ({{
                            item.rab_item != null
                              ? item.rab_item.product_name
                              : ''
                          }}) <v-icon x-small> mdi-arrow-right </v-icon> ({{
                            item.product.name
                          }})
                        </span>
                        <br />
                      </div>
                      <span v-if="item.rab_qty_gap < 0">
                        Qty FPB ({{ item.qty }}) melebihi Sisa Qty RAB ({{
                          item.rab_qty_gap
                        }})
                      </span>
                    </div>
                    <span
                      class="red--text"
                      style="font-size: 12px; font-weight: bolder"
                    >
                      HARAP PERBEDAAN INI DIBUATKAN RAB TAMBAHAN !!!
                    </span>
                  </div>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :style="`
                                text-align: left;
                                width: 250px;
                                font-size: 12px;
                                padding: 0;
                                color: ${
                                  item.is_subtitute || item.rab_qty_gap < 0
                                    ? 'red'
                                    : ''
                                };`"
                    >
                      {{
                        `${
                          item.product.code !== null
                            ? '(' + item.product.code + ')'
                            : ''
                        } ${item.product.name}`
                      }}
                    </div>
                  </template>
                  <span>
                    {{
                      `${
                        item.product.code !== null
                          ? '(' + item.product.code + ')'
                          : ''
                      } ${item.product.name}`
                    }}</span
                  >
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.pr_status`]="{ item }">
              <div
                :style="`color: ${colorStatus(
                  item.pr_status
                )}; width: 75px; font-size:13px; font-weight:bolder;`"
              >
                {{ item.pr_status != null ? item.pr_status.name : null }}
              </div>
            </template>
            <template v-slot:[`item.prd_status`]="{ item }">
              <div style="width: 75px">
                <div v-if="item.prd_status.id == 0" @click.prevent>
                  <td
                    style="
                      border: 0.5px solid rgb(0, 0, 0, 0.8);
                      font-size: 12px;
                      border-radius: 50%;
                      height: 22px;
                      width: 22px;
                      color: white;
                      font-weight: bold;
                      background-color: rgba(0, 0, 0, 0.8);
                    "
                    class="d-flex justify-center align-center"
                  >
                    D
                  </td>
                </div>
                <div bottom v-if="item.prd_status.id == 1" @click.prevent>
                  <td
                    style="
                      border: 0.5px solid orange;
                      font-size: 12px;
                      border-radius: 50%;
                      height: 22px;
                      width: 22px;
                      color: white;
                      font-weight: bold;
                      background-color: orange;
                    "
                    class="d-flex justify-center align-center"
                  >
                    W
                  </td>
                </div>
                <div
                  class="d-flex"
                  v-if="item.prd_status.id == 2"
                  @click.prevent
                >
                  <div
                    style="
                      border: 0.5px solid blue;
                      font-size: 12px;
                      border-radius: 50%;
                      height: 22px;
                      width: 22px;
                      color: white;
                      font-weight: bold;
                      background-color: blue;
                    "
                    class="d-flex justify-center align-center"
                  >
                    PR
                  </div>
                  <td
                    v-if="item.item.is_po_created"
                    style="
                      margin-left: 5px;
                      border: 0.5px solid blue;
                      font-size: 12px;
                      border-radius: 50%;
                      height: 22px;
                      width: 22px;
                      color: white;
                      font-weight: bold;
                      background-color: blue;
                    "
                    class="d-flex justify-center align-center"
                  >
                    PO
                  </td>
                </div>
                <div
                  v-if="item.prd_status.id == 3"
                  style="
                    border: 0.5px solid blue;
                    font-size: 12px;
                    border-radius: 50%;
                    height: 22px;
                    width: 22px;
                    color: white;
                    font-weight: bold;
                    background-color: blue;
                  "
                  class="d-flex justify-center align-center"
                >
                  CA
                </div>
                <div
                  v-if="item.prd_status.id == 4"
                  style="
                    border: 0.5px solid green;
                    font-size: 12px;
                    border-radius: 50%;
                    height: 22px;
                    width: 22px;
                    color: white;
                    font-weight: bold;
                    background-color: green;
                  "
                  class="d-flex justify-center align-center"
                >
                  CL
                </div>

                <td
                  v-if="item.prd_status.id == -1"
                  style="
                    border: 0.5px solid red;
                    font-size: 12px;
                    border-radius: 50%;
                    height: 22px;
                    width: 22px;
                    color: white;
                    font-weight: bold;
                    background-color: red;
                  "
                  class="d-flex justify-center align-center"
                >
                  R
                </td>

                <div
                  bottom
                  v-if="item.prd_status.id == 5"
                  style="
                    border: 0.5px solid red;
                    font-size: 12px;
                    border-radius: 50%;
                    height: 22px;
                    width: 22px;
                    color: white;
                    font-weight: bold;
                    background-color: red;
                  "
                  class="d-flex justify-center align-center"
                >
                  C
                </div>
              </div>
            </template>
            <template v-slot:[`item.qty`]="{ item }">
              <div
                v-if="
                  item.rab_qty_gap != null &&
                  item.rab_qty_gap != '' &&
                  item.rab_qty_gap < 0 &&
                  item.is_deviation_fulfilled != true
                "
              >
                <v-tooltip top color="white">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="d-flex"
                      style="
                        font-size: 12px;
                        font-weight: bold;
                        color: red;
                        position: relative;
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span> {{ item.qty }} </span>
                      <v-icon
                        color="red"
                        x-small
                        style="position: relative; top: -5px; right: 2px"
                      >
                        mdi-exclamation
                      </v-icon>
                    </span>
                  </template>
                  <div
                    style="
                      width: 250px;
                      border: 1px solid darkslategrey;
                      padding: 5px;
                      border-radius: 3px;
                      margin: 0;
                    "
                  >
                    <span class="black--text" style="font-size: 12px"
                      >Qty FPB ({{ item.qty }}) melebihi Sisa QTY RAB ({{
                        item.rab_qty_gap
                      }})</span
                    ><br />
                    <span
                      class="red--text"
                      style="font-size: 12px; font-weight: bolder"
                      >HARAP KELEBIHANNYA DIBUATKAN RAB TAMBAHAN !!!</span
                    >
                  </div>
                </v-tooltip>
              </div>
              <div style="font-size: 12px" v-else>
                {{ item.qty || 0 }}
              </div>
            </template>
            <template v-slot:[`item.rab_item`]="{ item }">
              <div v-if="item.rab_item != null">
                <v-tooltip top color="white">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="d-flex"
                      :style="`font-size: 12px; color:${
                        item.rab_qty_gap < 0 ? 'red' : ''
                      }`"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>
                        {{ item.rab_qty_gap }}
                      </span>
                    </span>
                  </template>
                  <div
                    v-if="item.rab_origin != null"
                    style="
                      max-width: 200px;
                      border: 1px solid darkslategrey;
                      padding: 5px;
                      border-radius: 3px;
                      margin: 0;
                    "
                  >
                    <v-chip label small color="primary">
                      {{ item.rab_origin.budget_no }}
                    </v-chip>
                  </div>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.uom`]="{ item }">
              <div style="font-size: 12px">
                {{ item.uom != null ? item.uom.name : null }}
              </div>
            </template>
            <template v-slot:[`item.is_subtitute`]="{ item }">
              <div style="font-size: 12px">
                {{ item.is_subtitute ? 'Yes' : 'No' }}
              </div>
            </template>
            <!-- <template v-slot:[`item.created_at`]="{ item }">
              <div style="width: 75px; font-size: 12px">
                {{ item.created_at }}
              </div>
            </template> -->
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="rabDialog" width="800" persistent>
      <v-form ref="entryFormRab" @submit.prevent="saveRab">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            FORMULIR RAB
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-row no-gutters>
              <v-col md="6" style="padding: 0; margin-top: 10px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Plant
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-autocomplete
                      v-model="paramAPI.company_id"
                      :items="dropdownCompany"
                      item-text="name"
                      item-value="id"
                      return-id
                      outlined
                      dense
                      readonly
                      style="height: 45px"
                    ></v-autocomplete>
                  </v-col>
                </div>
              </v-col>
              <v-col md="6" style="padding: 0; margin-top: 10px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Project
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-select
                      v-model="paramAPI.project_id"
                      :items="dropdownProject"
                      :item-text="getItemText"
                      :filter="customFilter"
                      item-value="id"
                      outlined
                      return-id
                      dense
                      readonly
                      style="height: 45px"
                    >
                    </v-select>
                  </v-col>
                </div>
              </v-col>
              <v-col md="6" style="padding: 0; margin-top: 10px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Nama RAB
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      style="height: 45px"
                      dense
                      outlined
                      v-model="formRab.name"
                      :rules="rules.rabNameRules"
                    />
                  </v-col>
                </div>
              </v-col>
              <v-col md="6" style="padding: 0; margin-top: 10px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Penanggung Jawab
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-autocomplete
                      :items="dropdownEmployee"
                      :search-input.sync="searchEmployee"
                      :rules="rules.rabEmployeeRules"
                      v-model="formRab.employee"
                      dense
                      clearable
                      outlined
                      item-text="name"
                      item-id="id"
                      hide-details
                      hide-no-data
                      return-object
                      style="height: 40px"
                    >
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-avatar>
                            <img :src="`${data.item.photo}`" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ data.item.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ data.item.company_name }}-{{ data.item.nik }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </div>
              </v-col>

              <v-col cols="12" style="padding: 0; margin-top: 10px">
                <v-data-table
                  :headers="selectedItemHeader"
                  :items="selectedData"
                  :items-per-page="10"
                  :loading="loading"
                  mobile-breakpoint="0"
                  style="border: 1px solid rgba(0, 0, 0, 0.2)"
                >
                  <template v-slot:[`item.product`]="{ item }">
                    <div class="d-flex">
                      <p style="margin: 0; font-size: 12px; width: 250px">
                        {{ item.product.name }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.qty_remain`]="{ item }">
                    <div class="d-flex xWidth50">
                      <p style="margin: 0; font-size: 12px">
                        {{ item.rab_qty_gap }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.qty`]="{ item }">
                    <div class="d-flex xWidth50">
                      <p style="margin: 0; font-size: 12px">{{ item.qty }}</p>
                    </div>
                  </template>
                  <template v-slot:[`item.qty_rab`]="{ item }">
                    <div style="width: 80px; height: 45px" class="d-flex">
                      <v-text-field
                        v-model="item.qty_rab"
                        autofocus
                        dense
                        small
                        type="number"
                        :min="1"
                        :max="Math.abs(item.rab_qty_gap)"
                        class="fontSize12"
                        single-line
                        :rules="item.is_subtitute ? [] : getQtyRules(item)"
                        disabled
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.is_subtitute`]="{ item }">
                    <div style="font-size: 12px">
                      {{ item.is_subtitute ? 'Yes' : 'No' }}
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              type="reset"
              @click="closeRabDialog"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              type="submit"
              text
              outlined
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <div style="position: fixed; bottom: 10px; right: 0">
      <Scanner />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
import * as XLSX from 'xlsx/xlsx.mjs'
import moment from 'moment'
export default {
  components: {
    Scanner: () => import('../../home/components/Scanner.vue')
  },
  data: () => ({
    wWidth: window.innerWidth,
    proc: buildType.apiURL('proc'),
    eSanqua: buildType.apiURL('esanqua'),
    hrsApi: buildType.apiURL('hrs'),
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      status: '',
      length: 0,
      sortBy: 'request_no',
      sortType: 'desc',
      itemsPerPage: 10,
      company_id: null,
      department_id: null,
      category_item: null,
      request_date_start: '',
      request_date_end: '',
      project_id: null,
      budget_plan_id: null
    },
    totalData: 0,
    result: [],
    detail: null,
    selected: null,
    loading: true,
    dropdownCompany: [],
    dropdownDepartment: [],
    dropdownProject: [],
    dropdownRab: [],
    isDisableCompanyDropdown: false,
    url: '',

    selectedData: [],

    actionValue: 0,
    rabDialog: false,
    searchEmployee: null,
    selectedEmployee: null,
    dropdownEmployee: [],
    rules: {
      rabNameRules: [],
      rabEmployeeRules: [],
      qtyRules: []
    },
    formRab: {
      name: null,
      employee: null
    }
  }),
  watch: {
    'paramAPI.sortBy'() {
      this.getDataFromApi()
    },
    'paramAPI.sortType'() {
      this.getDataFromApi()
    },
    'paramAPI.status'() {
      this.getDataFromApi()
    },

    searchEmployee(val) {
      if (val !== '') {
        val && val !== this.selectedEmployee && this.querySelections(val)
      } else {
        this.selectedEmployee = null
        this.dropdownEemployee = []
      }
      // this.odoo_project_code = null
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    dropdownCategoryItem() {
      const arr = [
        { id: 1, name: 'Raw Material' },
        { id: 2, name: 'Factory Supply' },
        { id: 3, name: 'Office Supply' },
        { id: 4, name: 'Sparepart' },
        { id: 5, name: 'Jasa' },
        { id: 6, name: 'Maintenance Repair' },
        { id: 7, name: 'Investment / Asset' }
      ]
      if (this.paramAPI.company_id == 5 || this.paramAPI.company_id == 14) {
        arr.splice(
          2,
          4,
          {
            id: 8,
            name: 'Office Supply (< 1jt)'
          },
          {
            id: 9,
            name: 'Office Supply (1jt-5jt)'
          },
          {
            id: 10,
            name: 'Office Supply (> 5j)'
          },
          {
            id: 11,
            name: 'Marketing Material (< 1jt)'
          },
          {
            id: 12,
            name: 'Marketing Material (1jt-5jt)'
          },
          {
            id: 13,
            name: 'Marketing Material (> 5j)'
          },
          {
            id: 14,
            name: 'Sparepart (< 1jt)'
          },
          {
            id: 15,
            name: 'Sparepart (1jt-5jt)'
          },
          {
            id: 16,
            name: 'Sparepart (> 5j)'
          },
          {
            id: 17,
            name: 'Jasa (< 1jt)'
          },
          {
            id: 18,
            name: 'Jasa (1jt-5jt)'
          },
          {
            id: 19,
            name: 'Jasa (> 5j)'
          },
          {
            id: 20,
            name: 'Maintenance Repair (< 1jt)'
          },
          {
            id: 21,
            name: 'Maintenance Repair (1jt-5jt)'
          },
          {
            id: 22,
            name: 'Maintenance Repair (> 5j)'
          }
        )
      }
      return arr
    },
    deviationHeaders() {
      const arr = [
        {
          text: 'No. Request',
          value: 'request_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Project',
          value: 'project',
          align: 'left',
          sortable: false
        },
        {
          text: 'RAB',
          value: 'rab',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama Barang',
          value: 'product',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty',
          value: 'qty',
          align: 'left',
          sortable: false
        },
        {
          text: 'Sisa RAB',
          value: 'rab_item',
          align: 'left',
          sortable: false
        },
        {
          text: 'Unit',
          value: 'uom',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status FPB',
          value: 'pr_status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status Item',
          value: 'prd_status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Subtitusi',
          value: 'is_subtitute',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    },
    itemsAction() {
      const arr = []
      arr.push({ id: 0, name: '' }, { id: 1, name: 'Buat RAB Revisi' })
      return arr
    },

    selectedItemHeader() {
      const arrHeaders = [
        {
          text: 'Nama Barang',
          value: 'product',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty',
          value: 'qty_rab',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty Lebih',
          value: 'qty_remain',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty FPB',
          value: 'qty',
          align: 'left',
          sortable: false
        },
        {
          text: 'Subtitusi',
          value: 'is_subtitute',
          align: 'left',
          sortable: false
        }
      ]
      return arrHeaders
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    // if (this.getFpbParam != null) {
    //   this.paramAPI = this.getFpbParam
    // }
    setTimeout(async () => {
      await this.getDataFromApi()
      await this.initDropdown()
      // await this.getFpbProjectEstimateNotif()
    }, 200)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText != undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn,
            cancelButtonText: noBtn != '' ? noBtn : 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    actionSelect(event) {
      let xProjectIds = null
      switch (event) {
        case 0:
          this.selectedData = []
          // this.initDropdown()
          break
        case 1:
          // Cek apakah semua item punya project.id yang sama
          xProjectIds = new Set(
            this.selectedData.map((item) => item.project?.id)
          )
          if (xProjectIds.size == 1) {
            this.createRAB()
            // console.log('create RAB >>>', xProjectIds)
          } else {
            this.showMsgDialog(
              'warning',
              'Barang yang diproses harus dari daftar project yang sama',
              false,
              'Ok'
            )
          }
          break
      }
    },
    clearSelection() {
      setTimeout(() => {
        this.selectedData = []
        this.actionValue = 0
      }, 10)
    },
    closeRabDialog() {
      this.rabDialog = false
      this.formRab.employee = null
      this.formRab.name = null
      this.clearSelection()
    },
    createRAB() {
      console.log('create rab>>>', this.selectedData)
      if (this.selectedData.length == 0) {
        this.showMsgDialog(
          'warning',
          'Pilih minimal satu item untuk melanjutkan pembuatan FPB',
          false,
          'Ok'
        )
        setTimeout(() => {
          this.actionValue = 0
        }, 50)
        return null
      }
      if (
        this.paramAPI.company_id == null ||
        this.paramAPI.project_id == null ||
        this.paramAPI.company_id == '' ||
        this.paramAPI.project_id == ''
      ) {
        this.showMsgDialog(
          'warning',
          'Harap pilih plant dan project untuk melanjutkan',
          false,
          'Ok'
        )
        this.clearSelection()
        return null
      }
      for (let i = 0; i < this.selectedData.length; i++) {
        if (this.selectedData[i].rab_qty_gap != null) {
          // console.log('rab_qty_gap', this.selectedData[i].rab_qty_gap)
          // console.log('qty', this.selectedData[i].qty)
          if (
            // this.selectedData[i].rab_qty_gap >= 0 &&
            this.selectedData[i].is_subtitute
          ) {
            // console.log('qty', this.selectedData[i].qty)
            this.selectedData[i].qty_rab = this.selectedData[i].qty
          } else {
            this.selectedData[i].qty_rab = Math.abs(
              this.selectedData[i].rab_qty_gap
            )
          }
        }
        // this.selectedData[i].rab_qty_gap != null &&
        // this.selectedData[i].rab_qty_gap != ''
        //   ? Math.abs(this.selectedData[i].rab_qty_gap)
        //   : null
      }

      setTimeout(() => {
        this.rabDialog = true
      }, 300)
    },
    addItem() {
      // this.initDropdown()
      setTimeout(() => {
        document.getElementById('fpbFormCreate').click()
      }, 500)
    },
    rowClick(pValue, pSlot) {
      // const arrItem = {
      //   list: []
      // }
      // this.$store.commit('setFpbList', arrItem)
      // setTimeout(() => {
      //   this.$router.push(
      //     `/e-catalogue/fpb-list/fpb/${pValue.id}?idx=${pSlot.index}`
      //   )
      // }, 200)
    },
    async changeCompany(p) {
      this.paramAPI.company_id = p

      this.clearPaging()
      await this.getDataFromApi()
      await this.getDropdownDepartment()
      await this.getDropdownProject()
      await this.getDropdownRab()
      // await this.getFpbProjectEstimateNotif()
    },
    async changeDepartment(p) {
      this.paramAPI.department_id = p
      this.clearPaging()
      await this.getDataFromApi()
    },
    async changeCategory(p) {
      this.paramAPI.category_item = p
      this.clearPaging()
      await this.getDataFromApi()
    },
    startDateWatcher() {
      this.clearPaging()
      this.getDataFromApi()
    },
    endDateWatcher() {
      this.clearPaging()
      this.getDataFromApi()
    },
    projectWatcher() {
      this.clearPaging()
      this.getDataFromApi()
    },
    rabWatcher() {
      this.clearPaging()
      this.getDataFromApi()
    },
    async initDropdown() {
      await this.getDropdownCompany()
      await this.getDropdownDepartment()
      this.getDropdownProject()
      this.getDropdownRab()
    },
    async getDropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) =>
          id === '3' || id === '14' || id === '23' || id === '27' || id === '41'
      )
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdownCompany = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
      } else {
        this.dropdownCompanyApi()
      }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = true
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdownCompany = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDropdownDepartment() {
      await axios
        .get(
          `${this.hrsApi}master/universal/department/dropdown?filter=[{"company_id":${this.paramAPI.company_id}}]`
        )
        .then((res) => {
          console.log(res)
          if (res.data.status_code === '00') {
            return (this.dropdownDepartment = res.data.data)
          }
          return (this.dropdownDepartment = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdownDepartment = [])
        })
    },
    async getDropdownProject() {
      let url = `${this.proc}globalmaster/project/dropdown?keyword=`
      if (this.paramAPI.company_id !== null) {
        url = url + `&filter=[{"company_id":${this.paramAPI.company_id}}]`
      }
      console.log(url)
      axios
        .get(url)
        .then((res) => {
          this.dropdownProject = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDropdownRab() {
      let url = `${this.proc}rab/dropdown?keyword=`
      if (this.paramAPI.company_id !== null) {
        url = url + `&filter=[{"company_id":${this.paramAPI.company_id}}]`
      }
      if (this.paramAPI.project_id !== null) {
        url = url + `&filter=[{"project_id":${this.paramAPI.project_id}}]`
      }
      console.log(url)
      axios
        .get(url)
        .then((res) => {
          this.dropdownRab = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDataFromApi() {
      this.loading = true
      this.clearSelection()
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = Number(data.total_record)
            return (this.result = data.data)
          } else {
            this.totalData = 0
            return (this.result = [])
          }
          // return this.showMsgDialog('warning', data.status_msg, 'false')
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.loading = false
    },

    saveRab() {
      // console.log(this.formRab)
      // console.log(this.odoo_project_code, this.company)
      const self = this
      this.rules.rabNameRules = [(v) => !!v || 'Nama rab harus diisi']
      this.rules.rabEmployeeRules = [
        (v) => !!v || 'Penanggung jawab harus diisi'
      ]
      // this.rules.qtyRules = [
      //   (v) => !!v || 'Harus diisi',
      //   (v) => v > 0 || 'Tidak boleh 0'
      // ]

      setTimeout(function () {
        if (self.$refs.entryFormRab.validate()) {
          self
            .showMsgDialog(
              'question',
              'Buat RAB Revisi dari item-item berikut ini sekarang?',
              true,
              'Submit',
              'Batal'
            )
            .then(async (res) => {
              if (res.isConfirmed) {
                const xLastCheck = self.selectedData.find(
                  ({ qty_rab, rab_qty_gap, is_subtitute }) =>
                    qty_rab < 1 && qty_rab > Math.abs(rab_qty_gap)
                )
                if (xLastCheck != undefined) {
                  self.showMsgDialog(
                    'warning',
                    'Qty yang diajukan tidak boleh kurang dari 0 ataupun melebihi selisih yang tersedia',
                    false,
                    'Ok'
                  )
                  // return
                }
                self.newFormRab()
              } else {
                // self.clearSelection()
              }
            })
        }
      })
    },
    newFormRab() {
      let xProject = null
      let xCompany = null
      const xFindProject = this.dropdownProject.find(
        ({ id }) => id == this.paramAPI.project_id
      )
      const xFindCompany = this.dropdownCompany.find(
        ({ id }) => id == this.paramAPI.company_id
      )
      if (xFindProject != undefined) {
        xProject = xFindProject
      }
      if (xFindCompany != undefined) {
        xCompany = xFindCompany
      }
      const form = {
        act: 'add_batch_in_item',
        name: this.formRab.name,
        pic_employee_id: Number(this.formRab.employee.id),
        pic_employee_nik: this.formRab.employee.nik,
        pic_employee_name: this.formRab.employee.name,
        rab_type: 2,
        budget_plan_detail: []
      }

      if (xProject != null) {
        Object.assign(form, {
          project_id: xProject.id,
          project_name: xProject.name,
          project_code: xProject.code
        })
      }
      if (xCompany != null) {
        Object.assign(form, {
          company_id: xCompany.id,
          company_name: xCompany.name,
          company_code: this.getCompanyAlias(xCompany.id)
        })
      }
      for (let i = 0; i < this.selectedData.length; i++) {
        const obj = {
          product_id: this.selectedData[i].product.id,
          product_name: this.selectedData[i].product.name,
          product_code: this.selectedData[i].product.code,
          qty: this.selectedData[i].qty_rab,
          // qty_remain: 0,
          budget_price_per_unit: this.selectedData[i].budget_price_per_unit,
          estimate_date_use: this.selectedData[i].estimate_date_use,
          description: this.selectedData[i].product.name,
          rab_origin_id:
            this.selectedData[i].rab_origin != null
              ? this.selectedData[i].rab_origin.id
              : null,
          deviation_fpb_item_id: this.selectedData[i].prd_id
          // type: '',
          // merk: '',
          // dimension: '',
          // material: ''
        }
        if (i == 0) {
          if (this.selectedData[i].department != null) {
            Object.assign(form, {
              department_id: this.selectedData[i].department.id,
              department_name: this.selectedData[i].department.name
            })
          }
        }
        if (this.selectedData[i].product_id == null) {
          Object.assign(obj, {
            category_id: 104,
            category_name: 'Lain-lain'
          })
        }
        if (this.selectedData[i].uom != null) {
          Object.assign(obj, {
            uom_id: this.selectedData[i].uom.id,
            uom_name: this.selectedData[i].uom.name
          })
        }
        if (this.selectedData[i].vendor != null) {
          Object.assign(obj, {
            vendor_id: this.selectedData[i].vendor.id,
            vendor_name: this.selectedData[i].vendor.name,
            vendor_code: this.selectedData[i].vendor.code
          })
        }
        if (this.selectedData[i].currency != null) {
          Object.assign(obj, {
            currency_id: this.selectedData[i].currency.id,
            currency_symbol: this.selectedData[i].currency.symbol,
            currency_code: this.selectedData[i].currency.code
          })
        }

        form.budget_plan_detail.push(obj)
      }
      console.log('payload>>>>', form)
      this.submitRab(form)
    },
    submitRab(form) {
      this.loading = true
      axios
        .post(`${this.proc}rab/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            const created_id = res.data.created_id
            this.$router.push(`/e-catalogue/rab/detail/${created_id}`)
          } else {
            this.showMsgDialog('error', res.data.status_msg, false, 'Ok')
          }
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    initDataTable() {
      // http://localhost:9191/api/procurement/v1/
      let url = `${this.proc}fpb/item/deviation/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}`

      if (this.paramAPI.company_id !== null) {
        url = url + `&company_id=${this.paramAPI.company_id}`
      }
      if (this.paramAPI.department_id !== null) {
        url = url + `&department_id=${this.paramAPI.department_id}`
      } else {
        url = url + '&department_id='
      }
      if (this.paramAPI.category_item !== null) {
        url = url + `&category_item=${this.paramAPI.category_item}`
      }
      // if (this.paramAPI.request_date_start !== null) {
      //   url = url + `&request_date_start=${this.paramAPI.request_date_start}`
      // }
      // if (this.paramAPI.request_date_end !== null) {
      //   url = url + `&request_date_end=${this.paramAPI.request_date_end}`
      // }
      if (this.paramAPI.project_id !== null) {
        url = url + `&project_id=${this.paramAPI.project_id}`
      }
      if (this.paramAPI.budget_plan_id !== null) {
        url = url + `&budget_plan_id=${this.paramAPI.budget_plan_id}`
      }

      this.url = url
      // this.$store.commit('setFpbItems', this.paramAPI)
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    refreshData() {
      this.getDataFromApi()
      // this.getFpbProjectEstimateNotif()
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    async searchEnter() {
      await this.getDataFromApi()
    },
    clearPaging() {
      this.paramAPI.page = 1
      this.paramAPI.offset = 0
      this.paramAPI.limit = 10
      this.paramAPI.itemsPerPage = 10
    },
    colorStatus(val) {
      switch (val.id) {
        case -1:
          return 'red'
        case 0:
          return '#1976d2'
        case 1:
          return 'orange'
        case 2:
          return 'green'
        case 3:
          return '#4CAF50'
        case 4:
          return 'red'
        case 5:
          return 'black'
      }
    },
    async exportData() {
      // let url = `${this.proc}fpb/list?keyword=${this.paramAPI.keyword}&offset=0&limit=all&order_by=request_no&order_type=asc&status=&department_id=&request_date_start=&request_date_end=`
      // if (this.paramAPI.company_id !== null) {
      //   url = url + `&company_id=${this.paramAPI.company_id}`
      // }
      const url = this.url + '&is_export=true'
      await axios
        .get(url)
        .then((res) => {
          console.log(res)
          let selectedData = []
          const response = res.data.data
          if (response !== undefined) {
            for (let i = 0; i < response.length; i++) {
              selectedData.push({
                request_no: response[i].request_no,
                employee: response[i].employee.name,
                department: response[i].department.name,
                company: response[i].company.name,
                submit_date: response[i].requested_at,
                status: response[i].status.name,
                created_at: response[i].created_at,
                item: response[i].item
              })
            }
            this.exportNow(selectedData)
          } else {
            selectedData = []
          }
          return null
        })
        .catch((error) => {
          console.log(error)
          return null
        })
    },
    exportNow(selectedData) {
      const arrData = []
      for (let i = 0; i < selectedData.length; i++) {
        const param = {
          request_no: selectedData[i].request_no,
          employee: selectedData[i].employee,
          department: selectedData[i].department,
          company: selectedData[i].company,
          submit_date: selectedData[i].submit_date,
          created_at: selectedData[i].created_at,
          status_fpb: selectedData[i].status,
          product_code: selectedData[i].item.product_code,
          product_name: selectedData[i].item.product_name,
          qty: selectedData[i].item.qty,
          uom: selectedData[i].item.uom_name,
          quotation_per_unit: selectedData[i].item.quotation_price_per_unit,
          budget_per_unit: selectedData[i].item.budget_price_per_unit,
          budget_total: selectedData[i].item.budget_price_total,
          last_price: selectedData[i].item.last_price,
          pr_no: selectedData[i].item.pr_no,
          status_item: selectedData[i].item.status,
          status_item_name: selectedData[i].item.status_name,
          is_po_created: selectedData[i].item.is_po_created,
          date_use: selectedData[i].item.estimate_date_use,
          description: selectedData[i].item.description
        }
        arrData.push(param)
      }
      this.downloadExcell(arrData)
    },
    downloadExcell(arrData) {
      const data = XLSX.utils.json_to_sheet(arrData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      const date = new Date()
      XLSX.writeFile(wb, `FPB_${date.toLocaleDateString('id')}.xlsx`)
    },
    price(pItem) {
      if (pItem !== undefined) {
        if (pItem !== null) {
          return pItem.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',')
        }
      }
      return ''
    },
    convertDate(val, str) {
      const raw = val
      if (raw != null && raw != '') {
        // const date = new Date(raw)
        const local = moment(val).format('DD-MM-YYYY')
        return local
      }
    },

    countdown(raw) {
      if (raw !== null) {
        const startDate = this.$moment(new Date(), 'YYYY/MM/DD')
        const endDate = this.$moment(raw, 'YYYY/MM/DD')

        var duration = moment.duration(endDate.diff(startDate))
        var days = duration.asDays()
        // console.log(days)
        return days
      }
    },

    getItemText(item) {
      return `(${item.code}) ${item.name}`
    },
    customFilter(item, queryText, itemText) {
      // eslint-disable-next-line no-unused-vars
      const text = itemText.toLowerCase()
      const query = queryText.toLowerCase()
      return (
        item.code.toLowerCase().includes(query) ||
        item.name.toLowerCase().includes(query)
      )
    },

    querySelections(v) {
      axios
        .get(`${this.hrsApi}employee/dropdown?keyword=${v}`)
        .then((res) => {
          console.log(res)
          this.loading = false
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              resArr.push({
                id: res.data.data[i].id,
                nik: res.data.data[i].nik,
                name: res.data.data[i].name,
                company_id: res.data.data[i].company_id,
                company_name: this.getCompanyAlias(res.data.data[i].company_id),
                photo: res.data.data[i].photo
              })
            }
            return (this.dropdownEmployee = resArr)
          }
          return (this.dropdownEmployee = [])
        })
        .catch((err) => {
          this.dropdownEmployee = []
          return console.log(err)
        })
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'TMP2'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'KAJ2'
      }
    },
    getQtyRules(item) {
      return [
        (v) => !!v || 'Harus diisi',
        (v) => v > 0 || 'Min = 1',
        (v) =>
          v <= Math.abs(item.rab_qty_gap) ||
          `Max = ${Math.abs(item.rab_qty_gap)}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.fontSize12 {
  font-size: 12px;
}
</style>
